import React, {useState} from "react"
import PropTypes from "prop-types"

import ShelfApi from "~/utils/ShelfApi"
import {DetailInfoRow, LoadingIndicator} from "~/components/"
import {useTranslation} from "react-i18next"

export const ArticleDocumentForm = ({barcode}) => {
  const {t} = useTranslation()
  const [title, setTitle] = useState("")
  const [loading, setLoading] = useState(false)
  const [statusText, setStatusText] = useState("")

  const attachDocument = () => {
    if (loading) return
    setLoading(true)
    setStatusText("")

    const formData = new FormData()
    const fileInput = document.querySelector("#document")
    formData.append("article_document[title]", title)
    formData.append("article_document[file]", fileInput.files[0])

    ShelfApi.post(`/articles/${barcode}/article_documents`, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
      .then(() => {
        setStatusText(t("articles.detail.uploadSuccessful"))
        window.location.reload(false)
      })
      .catch(res => {
        setStatusText(t("articles.detail.uploadFailed"))
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <DetailInfoRow label="Dokument hochladen">
      <div style={styles.inner}>
        <label htmlFor="name">
          <span>{t("articles.detail.documentTitle")}</span>
          <input
            type="text"
            name="title"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </label>
        <label>
          <span>{t("articles.detail.document")}</span>
          <input
            type="file"
            id="document"
            name="document"
            style={styles.fileInput}
          />
        </label>
        <div style={styles.actionRow}>
          <p style={styles.statusText}>{statusText}</p>
          {loading && <LoadingIndicator message={""} />}
          <a className="sh-button sh-button--primary" onClick={attachDocument}>
            {t("articles.detail.upload")}
          </a>
        </div>
      </div>
    </DetailInfoRow>
  )
}

const styles = {
  inner: {
    padding: "6px 12px"
  },
  fileInput: {
    backgroundColor: "#FFF"
  },
  actionRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 12
  },
  statusText: {
    fontSize: "1.3em",
    paddingTop: "8px"
  }
}

ArticleDocumentForm.propTypes = {
  barcode: PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/forms/ArticleDocumentForm.js